export const CombosEnum = {
  essencial: 1,
};
